import { LimitBuySummary } from '@/lib/components/OrderForm/OrderSummary/LimitBuySummary';
import { LimitSellSummary } from '@/lib/components/OrderForm/OrderSummary/LimitSellSummary';
import { MarketBuySummary } from '@/lib/components/OrderForm/OrderSummary/MarketBuySummary';
import { MarketSellSummary } from '@/lib/components/OrderForm/OrderSummary/MarketSellSummary';
import { useOrderFormStore } from '@/lib/store/order-form-store';
import { EMarketAction } from '@/lib/types/market-action';
import { EMarketOrderType } from '@/lib/types/market-order-type';
import { PotentialPayout } from './PotentialPayout';

export const OrderSummary = () => {
  // CRITICAL FIX: Use specific selectors
  const action = useOrderFormStore.use.action();
  const orderType = useOrderFormStore.use.orderType();
  const amountUsd = useOrderFormStore.use.amountUsd();
  const sharesCount = useOrderFormStore.use.sharesCount();

  // Check if form is empty
  const isFormEmpty = amountUsd.eq(0) && sharesCount.eq(0);

  // Show Potential Payout only for MARKET orders when form is empty and action is BUY
  if (isFormEmpty && action === EMarketAction.BUY && orderType === EMarketOrderType.MARKET) {
    return <PotentialPayout />;
  }

  return (
    <div className="flex flex-col gap-1">
      {orderType === EMarketOrderType.MARKET && action === EMarketAction.BUY ? (
        <MarketBuySummary />
      ) : null}
      {orderType === EMarketOrderType.MARKET && action === EMarketAction.SELL ? (
        <MarketSellSummary />
      ) : null}
      {orderType === EMarketOrderType.LIMIT && action === EMarketAction.BUY ? (
        <LimitBuySummary />
      ) : null}
      {orderType === EMarketOrderType.LIMIT && action === EMarketAction.SELL ? (
        <LimitSellSummary />
      ) : null}
    </div>
  );
};
